import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_API_URL } from "../../../core/environment.tokens";
import { ChaseUnasssignModel } from "./chase-unassign-model";

@Injectable({
  providedIn: "root",
})
export class UnassignChaseService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient
  ) { }

  unassignChases(chaseUnassignModel: ChaseUnasssignModel): Observable<any> {

    const url = `${this.baseApiUrl}chase/unassignChases`;

    return this.http.post(url, chaseUnassignModel);

  }


}
